import { Outlet } from 'react-router-dom';
import { AppLayout } from 'components/layout/AppLayout';
import CirculerShadow from 'components/ui/CirculerShadow';

export const Dashboard = () => {
  return (
    <AppLayout>
      <div className="relative">
        <div className="z-[9999]">
          <Outlet />
        </div>
        <div className="absolute -z-10 md:visible invisible top-0 right-0 ">
          <CirculerShadow className="size-[450px] " />
        </div>
        <div className="absolute md:visible -z-10 invisible bottom-24 -left-2 bg-left-bottom">
          <CirculerShadow className="" />
        </div>
      </div>
    </AppLayout>
  );
};
